import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";

// this will enable HMR for custom handlers
/* istanbul ignore next */
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

const customemailsUrl = "/api/v1/teemail";

// the chain is just an array, so it can be modified directly instead of using the helper functions
replaceInChain(chain, PopulateApiParameter, props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        topic: state.fieldValues["topic"],
        firstName: state.fieldValues["firstName"],
        lastName: `${state.fieldValues["company"]}|${state.fieldValues["website"]}`,
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        message: `${state.fieldValues["message"]}|${state.fieldValues["brand"]}|${state.fieldValues["sku"]}`,
        emailTo: props.parameter.emailRecipients,
    };
});

export interface SubmitContactUsFormApiParameter extends ApiParameter {
    topic?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    emailTo?: string;
}

replaceInChain(chain, SendDataToApi, async props => {
    await submitContactUsForm(props.apiParameter);
});

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter, void>(`${customemailsUrl}/contactUs`, parameter);
}
